'use client';
import { useSearchParams } from 'next/navigation';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { textBlock } from '@/uiPrimitives/typography/text';
import { box } from '@/uiPrimitives/layout/box';
import { linkInlineCSS } from '@/uiComposites/interactive/link.css';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { useDOPRouter } from '@/globals/routing/DOPRouter';
import { Language } from './Glossary.types';
import { startTransition, useOptimistic } from 'react';
import { pageGrid } from '@/uiPrimitives/layout/pageGrid/pageGrid';

export const GlossarySort = ({ language }: { language: Language }) => {
	const router = useDOPRouter();

	const [optimisticLanguage, setOptimisticLanguage] = useOptimistic<
		Language,
		Language
	>(language, (_language, optimisticLanguage) => {
		return optimisticLanguage;
	});
	const searchParams = useSearchParams();
	return (
		<div className={classes(pageGrid({ columnCount: '10-of-12' }))}>
			<div
				className={classes(
					shelf({ gap: '-2 | smaller' }),
					box({ paddingBlockStart: '2 | h2' }),
				)}
				{...addTestSelector('uiSortLinks')}
			>
				<span className={classes(textBlock({}))}>{'Sort:'}</span>
				{optimisticLanguage === 'en' ? (
					<span className={classes(textBlock({ color: 'positiveMuted' }))}>
						{'English'}
					</span>
				) : (
					<button
						type={'button'}
						data-link-type="sort-glossary-language"
						onClick={() => {
							startTransition(() => {
								const params = new URLSearchParams(searchParams);
								params.delete('lang');
								router.replace(`?${params.toString()}`, { scroll: false });
								setOptimisticLanguage('en');
							});
						}}
						className={classes(
							linkInlineCSS,
							textBlock({ color: 'positiveBlue:noVisited' }),
						)}
					>
						{'English'}
					</button>
				)}
				<span className={textBlock({})}>{'/'}</span>
				{optimisticLanguage === 'en' ? (
					<button
						type={'button'}
						data-link-type="sort-glossary-language"
						onClick={() => {
							startTransition(() => {
								const params = new URLSearchParams(searchParams);
								params.set('lang', 'nl');
								router.replace(`?${params.toString()}`, { scroll: false });
								setOptimisticLanguage('nl');
							});
						}}
						className={classes(
							linkInlineCSS,
							textBlock({ color: 'positiveBlue:noVisited' }),
						)}
					>
						{'Dutch'}
					</button>
				) : (
					<span className={classes(textBlock({ color: 'positiveMuted' }))}>
						{'Dutch'}
					</span>
				)}
			</div>
		</div>
	);
};
